import { Component, Input } from '@angular/core';
import { ModalContent } from '@src/shared/modal/confirm-modal/confirm-modal.type';
import { ModalService } from '@src/shared/modal/modal.service';
import { GoogleTagManagerService } from '../../../../woo_services.module/GoogleTagManagerService';
import { RoutingService } from '../../../../woo_services.module/RoutingService';
import { Campaign } from '../../../../woo_services.module/shared-types';

@Component({
  selector: 'duplicate-campaign-button',
  template: `
    <text-button icon="thumbs-single-row" [disabled]="disabled" (click)="onClick()"> Duplicera </text-button>
  `,
  standalone: false,
})
export class DuplicateCampaignButton {
  @Input() campaign: Campaign;
  @Input() disabled = false;

  constructor(
    private googleTagManagerService: GoogleTagManagerService,
    private routingService: RoutingService,
    private modalService: ModalService,
  ) {}

  onClick = (): void => {
    if (this.disabled) {
      return;
    }

    const content = this.getDialogContent();
    this.modalService
      .openConfirm(content)
      .then(
        (response) => {
          if (response.confirm) {
            this.duplicateCampaign(this.campaign);
          }
        },
        () => null,
      )
      .catch(() => {
        const msg = 'Ajdå, nånting gick snett. Var god försök igen!';
        this.modalService.openError(msg);
      });
  };

  private duplicateCampaign = (campaign: Campaign) => {
    this.googleTagManagerService.duplicateCampaign('specific');
    this.routingService.navigate(['/campaigns', 'new'], { state: { id: campaign.id, templating: true } });
  };

  private getDialogContent = (): ModalContent => ({
    title: 'Duplicera kampanj',
    texts: [
      'Du är nu på väg att duplicera en kampanj. Det innebär att allt kopieras från den tidigare kampanjen till den nya, förutom namn och kampanjperiod. Eventuella perioder för filmerna behöver också sättas om.',
      `Vill du fortsätta duplicera kampanjen <strong>${this.campaign.name}</strong>?`,
    ],
    confirmLabel: 'Duplicera kampanj',
    cancelLabel: 'Avbryt',
  });
}
